// src/components/LanguageSwitcher.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import './LanguageSwitcher.css';

const languages = [
  { code: 'en', icon: 'EN' },
  { code: 'ar', icon: 'ع' }
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  return (
    <motion.div
      className="lang-toggle-v2"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease: 'easeOut' }}
    >
      <div className="lang-toggle-container-v2">
        {languages.map(({ code, icon }) => {
          const isSelected = i18n.language === code;
          const baseClass = `lang-btn-${code}`;

          return (
            <motion.button
              key={code}
              className={baseClass}
              onClick={() => i18n.changeLanguage(code)}
              animate={{
                backgroundColor: isSelected ? '#00f7ff' : 'rgba(0,0,0,0)',
                color: isSelected ? '#000' : '#fff',
                boxShadow: isSelected
                  ? '0 0 14px #00f7ff99, inset 0 0 8px #00eaff'
                  : '0 0 0px transparent'
              }}
              transition={{ duration: 0.4, ease: 'easeInOut' }}
              whileHover={{
                scale: 1.1,
                color: isSelected ? '#000' : '#00f7ff'
              }}
            >
              <motion.span
                className="lang-icon"
                animate={
                  isSelected
                    ? {
                        scale: [1, 1.15, 1],
                        rotateY: [0, 180, 0],
                        textShadow: '0 0 8px #ffffffaa',
                        transition: {
                          duration: 0.8,
                          repeat: Infinity,
                          repeatType: 'mirror'
                        }
                      }
                    : { scale: 1, rotateY: 0, textShadow: 'none' }
                }
              >
                {icon}
              </motion.span>
            </motion.button>
          );
        })}
      </div>
    </motion.div>
  );
}
